module.exports = __webpack_public_path__ + "img/138.d6b97982.jpg";